module.exports = __webpack_public_path__ + "static/media/newsell.2a568160.webp";